import React from "react";
import logo from "../logo.svg";
import { Link, NavLink } from "react-router";

function NavBar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light sticky-top shadow-sm">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">
          <img
            src={logo}
            alt=""
            width="97"
            height="40"
            className="d-inline-block align-text-center ms-2"
            loading="lazy"
          />
        </Link>
        {/* navbar toggle button for small screen */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavAltMarkup"
          aria-controls="navbarNavAltMarkup"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
          <div className="navbar-nav d-flex justify-content-start w-75">
            {/* Apps*/}
            <NavLink
              className={`nav-link mx-2 fw-bold ${(e) => {
                return e.isActive() ? "active" : "";
              }}`}
              to="/explore_apps"
            >
              All PDF Tools
            </NavLink>

            {/* Compress PDF */}
            <NavLink
              className={`nav-link mx-2 ${(e) => {
                return e.isActive() ? "active" : "";
              }}`}
              to="/compress_pdf"
              state={{ title: "Compress PDF files" }}
            >
              Compress
            </NavLink>

            {/* Crop pdf */}
            <NavLink
              className={`nav-link mx-2 ${(e) => {
                return e.isActive() ? "active" : "";
              }}`}
              to="/crop_pdf"
              state={{ title: "Trim & Crop PDF Files Free" }}
            >
              Crop
            </NavLink>

            {/* Rotate pdf */}
            <NavLink
              className={`nav-link mx-2 ${(e) => {
                return e.isActive() ? "active" : "";
              }}`}
              to="/rotate_pdf"
              state={{ title: "Flip, Rotate PDF Files Free" }}
            >
              Rotate
            </NavLink>

            {/* Arrange pdf */}
            <NavLink
              className={`nav-link mx-2 d-lg-none ${(e) => {
                return e.isActive() ? "active" : "";
              }}`}
              to="/rearrange_pdf"
              state={{ title: "Re-arrange PDF Pages Inside Document Free" }}
            >
              Re-Arrange
            </NavLink>

            {/* Reduce PDF Size*/}
            <NavLink
              className={`nav-link mx-2 d-lg-none ${(e) => {
                return e.isActive() ? "active" : "";
              }}`}
              to="/compress_pdf"
              state={{ title: "Reduce PDF size" }}
            >
              Reduce Size
            </NavLink>

            {/* delete pages*/}
            <NavLink
              className={`nav-link mx-2 ${(e) => {
                return e.isActive() ? "active" : "";
              }}`}
              to="/delete_pdf_pages"
              state={{ title: "Remove Pages From PDF Document Free" }}
            >
              Remove Pages
            </NavLink>

            {/* extract pages*/}
            <NavLink
              className={`nav-link mx-2 ${(e) => {
                return e.isActive() ? "active" : "";
              }}`}
              to="/extract_pdf_pages"
              state={{ title: "Extract Pages From PDF Document Free" }}
            >
              Extract Pages
            </NavLink>

            {/* resize pdf*/}
            <NavLink
              className={`nav-link mx-2 d-lg-none ${(e) => {
                return e.isActive() ? "active" : "";
              }}`}
              to="/resize_pdf"
              state={{
                title: "Resize PDF Documents, Change PDF Page Size Free",
              }}
            >
              Resize
            </NavLink>

            {/* add page numbers pdf*/}
            <NavLink
              className={`nav-link mx-2 ${(e) => {
                return e.isActive() ? "active" : "";
              }}`}
              to="/number_pdf_pages"
              state={{
                title: "Add Page Numbers To PDF Document Free",
              }}
            >
              Page Number
            </NavLink>

            {/* image converter */}
            <NavLink
              className={`nav-link mx-2 ${(e) => {
                return e.isActive() ? "active" : "";
              }}`}
              to="/image_converter"
              state={{
                title: "Image Converter, Image Compressor Free",
              }}
            >
              Image Converter
            </NavLink>
          </div>

          {/* nav elements right */}
          <div className="navbar-nav d-flex justify-content-end w-25 d-none">
            {/* Pricing Button*/}
            <NavLink
              className={`nav-link mx-2 ${(e) => {
                return e.isActive() ? "active" : "";
              }}`}
              to="/pricing"
            >
              Pricing
            </NavLink>

            {/* Login Button*/}
            <NavLink
              className={`nav-link mx-2 ${(e) => {
                return e.isActive() ? "active" : "";
              }}`}
              to="/login"
            >
              Login
            </NavLink>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
